package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SeoContent() {
    Div({ classes("seo-panel") }) {
        H2 { Text("Карта АТЭС, штамп и визараны во Вьетнаме") }
        P {
            Text("Этот калькулятор помогает оценить реальную стоимость долгого проживания во Вьетнаме для удаленного специалиста или предпринимателя: не только прямую цену визарана, но и потерю рабочего дня, частоту выездов, инфляцию, риск ошибок и выгоду карты АТЭС.")
        }
        Div({ classes("seo-grid") }) {
            Div({ classes("seo-item") }) {
                Span({ classes("summary-label") }) { Text("Что сравнивается") }
                P { Text("Два сценария: въезды по штампу и карта АТЭС с лимитом пребывания за один въезд.") }
            }
            Div({ classes("seo-item") }) {
                Span({ classes("summary-label") }) { Text("Для кого") }
                P { Text("Для граждан РФ и русскоязычных экспатов, которые живут во Вьетнаме, работают удаленно и регулярно считают стоимость визовых решений.") }
            }
            Div({ classes("seo-item") }) {
                Span({ classes("summary-label") }) { Text("Что учитывается") }
                P { Text("Цена поездки, курс VND/RUB, доход, рабочие дни, срок пребывания, изменение правил, риск-дни, администрирование, дискомфорт и выгоды АТЭС в других странах.") }
            }
        }
        Div({ classes("faq-list") }) {
            Div({ classes("faq-item") }) {
                Span({ classes("summary-label") }) { Text("Что такое визаран?") }
                P { Text("Визаран - это выезд из страны и повторный въезд для обновления разрешенного срока пребывания. В расчете он влияет на транспортные расходы, частоту поездок и потерю рабочего времени.") }
            }
            Div({ classes("faq-item") }) {
                Span({ classes("summary-label") }) { Text("Почему карта АТЭС может быть выгодна?") }
                P { Text("Карта может снизить визовые и временные издержки, если человек часто въезжает во Вьетнам или путешествует по странам АТЭС. При этом сама карта стоит денег, поэтому ее нужно сравнивать с альтернативами.") }
            }
            Div({ classes("faq-item") }) {
                Span({ classes("summary-label") }) { Text("Как использовать реферальную скидку?") }
                P { Text("Если расчет показывает, что АТЭС подходит, пользователь может получить код на скидку и назвать его менеджеру при обращении. Воронка фиксирует клик, лид и потенциальную комиссию.") }
            }
        }
    }
}
